import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const InlineCTABase = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-areas:
    "img"
    "copy"
    "cta";
  border: 1px solid #d8dee1;
  border-radius: 2px;
  background-color: ${theme.colors.darkBlues[5]};
  color: ${theme.colors.darkBlues[100]};
  font-size: 21px;
  line-height: 27px;
  padding: 32px;
  justify-items: center;
  align-items: center;
  max-width: 844px;

  ${theme.largerThan.md} {
    padding: 24px;
  }

  ${theme.largerThan.sm} {
    justify-items: initial;
    padding: 24px;
    font-size: 28px;
    line-height: 36px;
    grid-template-areas:
      "img copy copy copy copy"
      "img copy copy copy copy"
      "img cta cta cta .";
  }
`;

export const ImageBasic = styled.img`
  max-height: 239px;
  width: 100%;
  grid-area: img;
  object-fit: cover;
  margin-bottom: 26px;
  border-radius: 5px;

  ${theme.largerThan.sm} {
    height: 198px;
    width: 198px;
    margin-right: 24px;
    margin-bottom: initial;
    justify-self: center;
  }
`;

export const Copy = styled.div`
  grid-area: copy;
  text-align: center;
  margin-bottom: 26px;
  width: 80%;

  ${theme.largerThan.sm} {
    width: 100%;
    padding-top: 16px;
    margin-bottom: 15px;
    text-align: left;
  }
`;

export const StyledCTA = styled(CTA)`
  grid-area: cta;

  ${theme.largerThan.sm} {
    margin-top: initial;
  }
`;
